import axios from 'axios'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'
import store from '../store'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*' },
  adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter))
})

const API = {
  HOME: '/assets/data/home.json',
  GETUSER: '/participant/:token'
}

function url (path, ...segments) {
  let i = 0
  const { state } = store
  const uri = path.replace(/:\w+/g, () => {
    let s = segments[i]
    i += 1
    return s
  })

  return uri
}

export default {
  install (Vue, options) {
    const $api = {
      getUser(token) {
        return http.get(url(API.GETUSER, token), { cache: false })
      },
      getHome() {
        return http.get(url(API.HOME))
      }
    }

    Vue.prototype.$api = $api
    Vue.$api = $api
  }
}
